import React from "react";

const MarketingActiveIcon = () => {
  return (
    <svg
      width="32"
      height="30"
      viewBox="0 0 32 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.41602 8.85536V3.68828C9.41602 2.57107 10.3138 1.59352 11.5108 1.31421C14.5033 0.895262 17.4958 0.895262 20.4883 1.31421C21.6853 1.45387 22.5831 2.43142 22.5831 3.68828V11.9277C22.5831 13.6035 21.0868 15 19.2913 15H12.7078C10.9123 15 9.41602 16.3965 9.41602 18.0723V26.3117C9.41602 27.4289 10.3138 28.4065 11.5108 28.6858C14.5033 29.1047 17.4958 29.1047 20.4883 28.6858C21.6853 28.5461 22.5831 27.5686 22.5831 26.3117V21.1446"
        stroke="#ffffff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5835 8.85498H28.1197C29.3167 8.85498 30.3641 9.69289 30.6633 10.8101C31.1122 13.6031 31.1122 16.3961 30.6633 19.1891C30.5137 20.3064 29.4663 21.1443 28.1197 21.1443H16M16 8.85498H3.8803C2.68329 8.85498 1.63591 9.69289 1.33666 10.8101C0.887781 13.6031 0.887781 16.3961 1.33666 19.1891C1.48628 20.3064 2.53367 21.1443 3.8803 21.1443H9.41646"
        stroke="#ffffff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MarketingActiveIcon;
